import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { installErrorForensics } from "@/lib/errorForensics";

// TEMPORARY (2026-08-21) — capturing the real exception behind the Safari
// "Script error." crash on the driver PWA install flow. See errorForensics.js.
installErrorForensics();

// ---- Sentry (optional; activates only when REACT_APP_SENTRY_DSN is set) ----
const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN;
if (SENTRY_DSN) {
  // Dynamic import so CRA can tree-shake when Sentry is off.
  import("@sentry/react").then((Sentry) => {
    Sentry.init({
      dsn: SENTRY_DSN,
      environment: process.env.REACT_APP_SENTRY_ENVIRONMENT || "production",
      release: process.env.REACT_APP_GIT_SHA || "dev",
      tracesSampleRate: Number(process.env.REACT_APP_SENTRY_TRACES_RATE || 0.05),
      // Never ship PII by default — rider names/phones live in every JSX tree.
      sendDefaultPii: false,
      // Scrub common PII fields from event payloads defensively.
      beforeSend(event) {
        try {
          const drop = (obj) => {
            if (!obj || typeof obj !== "object") return;
            for (const k of Object.keys(obj)) {
              if (/password|phone|email|secret|api[_-]?key|ssn|dob/i.test(k)) obj[k] = "[redacted]";
              else if (typeof obj[k] === "object") drop(obj[k]);
            }
          };
          drop(event.request?.data);
          drop(event.extra);
        } catch { /* never let scrubbing break Sentry */ }
        return event;
      },
    });
  }).catch(() => { /* silent — Sentry is nice-to-have */ });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
// NOTE: React.StrictMode intentionally disabled — its dev-only double-mount
// clashes with react-leaflet's map container initialization
// ("Map container is already initialized"). Prod builds are unaffected.
root.render(<App />);
